module.exports = __webpack_public_path__ + "static/media/80s.74484c9f.png";